import { random, shuffle } from 'lodash';

export const isEmpty = value => {
    if (Array.isArray(value)) {
        return !value.length;
    }
    if (typeof value === 'string') {
        return !value.length;
    }
    if (value === undefined || value === null) {
        return true;
    }
    if (
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        value instanceof Date
    ) {
        return false;
    }
    if (typeof value === 'object') {
        for (let _ in value) {
            return false;
        }
        return true;
    }
    return false;
};

export const isEmail = value => {
    const regex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;
    return regex.test(value);
};

export const isUrl = value => {
    const regex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
    return regex.test(value);
};

export const isPhone = (value, country) => {
    let countryCode = country === 'UK' ? country : 'DEFAULT';
    const phoneReg = {
        UK: '^(\\+44\\s)?\\(?\\d{2,3}\\)?[-\\s.]?\\d{4}[-\\s.]?\\d{4}$',
        DEFAULT:
            '^(\\+\\d{1,3}\\s)?\\(?\\d{2,3}\\)?[-\\s.]?\\d{3}[-\\s.]?\\d{4}$'
    };
    const regex = new RegExp(phoneReg[countryCode]);
    return regex.test(value);
};

export const isNumeric = value => {
    const regex = /^[0-9]*$/;
    return regex.test(value);
};

// check for alphanumeric with UTF-8 support
export const isAlphaNumeric = value => {
    const regex = /^[\p{L}\p{N}]+$/gu;
    return regex.test(value);
};

// check for alphanumeric with UTF-8 support
export const isAlphaNumericDash = value => {
    const regex = /^[\s\p{L}\p{N}_-]+$/gu;
    return regex.test(value);
};

// check for valid zip code based on the country
export const isZipCode = (value, country) => {
    const zipReg = {
        US: '^\\d{5}([-]?\\d{4})?$',
        UK:
            '^(GIR|[A-Z]\\d[A-Z\\d]??|[A-Z]{2}\\d[A-Z\\d]??)[ ]??(\\d[A-Z]{2})$',
        DE:
            '\\b((?:0[1-46-9]\\d{3})|(?:[1-357-9]\\d{4})|(?:[4][0-24-9]\\d{3})|(?:[6][013-9]\\d{3}))\\b',
        CA: '^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$',
        FR: '^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$',
        IT: '^(V-|I-)?[0-9]{5}$',
        AU:
            '^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$',
        NL: '^[1-9][0-9]{3}\\s?([a-zA-Z]{2})?$',
        ES: '^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$',
        DK: '^([D|d][K|k]( |-))?[1-9]{1}[0-9]{3}$',
        SE: '^(s-|S-){0,1}[0-9]{3}\\s?[0-9]{2}$',
        BE: '^[1-9]{1}[0-9]{3}$',
        IN: '^\\d{6}$'
    };
    const regex = new RegExp(zipReg[country]);
    return regex.test(value);
};

export const isMacAddress = value => {
    const regex = /^[a-fA-F0-9:]{17}|[a-fA-F0-9]{12}$/g;
    return regex.test(value);
};

export const randomElement = array => {
    // need to shuffle the input array to make sure the result
    // will be true random
    const shuffled = shuffle(array);
    const randomIndex =
        Math.round(
            (random(shuffled.length - 3) +
                random(shuffled.length - 3) +
                random(shuffled.length - 3)) /
                3
        ) %
        (shuffled.length - 3);
    return shuffled[randomIndex];
};

export const isEmptyValues = source => {
    // will check if the object values are empty or contains something
    if (isEmpty(source)) {
        return true;
    }
    return Object.values(source).filter(item => !isEmpty(item)).length === 0;
};

export const haveValues = sourceObject => {
    if (sourceObject) {
        return Object.values(sourceObject).filter(value => !!value).length > 0;
    }
    return false;
};

export const removeEmptyAttrs = source => {
    // will remove all attributes from the source object if it has
    // an empty value
    let newObject = {};
    if (source) {
        Object.keys(source).forEach(key => {
            if (
                typeof source[key] === 'boolean' ||
                typeof source[key] === 'number'
            ) {
                newObject[key] = source[key];
            } else if (source[key]) {
                newObject[key] = source[key];
            }
        });
    }
    return newObject;
};
